<onyx-modal
  variant="center"
  [size]="480"
  [heading]="`${I18N}.heading`"
  [close$]="close$"
  (keydown.enter)="next()"
  (closeModal)="dialogRef.close()"
>
  <form [formGroup]="form" [onyxAutoFocus]="true">
    @let controls = form.controls;
    <onyx-dropdown
      [formControl]="controls.country"
      label="labels.country"
      [options]="vatIdCountries$ | async"
      [search]="true"
      width="80px"
    ></onyx-dropdown>

    <onyx-text-field
      [formControl]="controls.vatId"
      label="labels.vatId"
    ></onyx-text-field>
  </form>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? next() : null">
      {{ 'labels.continue' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
